import { render, staticRenderFns } from "./CurrentUserAvatarDisplay.vue?vue&type=template&id=65a01570&scoped=true"
import script from "./CurrentUserAvatarDisplay.vue?vue&type=script&lang=js"
export * from "./CurrentUserAvatarDisplay.vue?vue&type=script&lang=js"
import style0 from "./CurrentUserAvatarDisplay.vue?vue&type=style&index=0&id=65a01570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a01570",
  null
  
)

export default component.exports